export enum OccupancyRentalBasicMenuEnum {
    overview = 0,
    residentialUnitsTypeWise,
    commercialUnitsSizeWise,
    unitRentalTransaction,
    unit,
    unitTransaction
}